// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__uOotM","loaderOuter":"PageOverlayLoader_loaderOuter__17y7P"};